export const datatypelist = [
  {
    id: "type1",
    tx: 16.101,
    ty: 631.9773,
    content: `<tspan x="0" y="0">Number of </tspan><tspan x="-4.08" y="14.4">married and </tspan><tspan x="-14.34" y="28.8">unmarried users </tspan><tspan x="-13.79" y="43.2">of contraception</tspan>`
  },
  {
    id: "type2",
    tx: 134.1359,
    ty: 639.1779,
    content: `<tspan x="0" y="0">Current method mix </tspan><tspan x="11.68" y="14.4"> and changes in </tspan><tspan x="15.2" y="28.8"> mix over time</tspan>`
  },
  {
    id: "type3",
    tx: 283.0109,
    ty: 631.9777,
    content: `<tspan x="0" y="0">Public/private </tspan><tspan x="16.37" y="14.4">split for </tspan><tspan x="-.06" y="28.8">where women </tspan><tspan x="5.17" y="43.2">get methods</tspan>`
  },
  {
    id: "type4",
    tx: 390.4023,
    ty: 631.9777,
    content: `<tspan x="0" y="0">Subsidized vs. </tspan><tspan x="-2.98" y="14.4">non-subsidized </tspan><tspan x="7.54" y="28.8">split within </tspan><tspan x=".94" y="43.2">private sector</tspan>`
  },
  {
    id: "type5",
    tx: 494.8064,
    ty: 646.3771,
    content: `<tspan x="0" y="0">Private sector </tspan><tspan x="19.46" y="14.4">prices</tspan>`
  },
  {
    id: "type6",
    tx: 611.5095,
    ty: 646.3774,
    content: `<tspan x="0" y="0">Public sector </tspan><tspan x="18.59" y="14.4">prices</tspan>`
  },
  {
    id: "type7",
    tx: 731.9567,
    ty: 631.9778,
    content: `<tspan x="0" y="0">Government </tspan><tspan x="8.14" y="14.4">spending </tspan><tspan x="-5.2" y="28.8">on commodity </tspan><tspan x="-.43" y="43.2">procurement</tspan>`
  },
  {
    id: "type8",
    tx: 866.9838,
    ty: 631.9778,
    content: `<tspan x="0" y="0">Donor and </tspan><tspan x="-16.82" y="14.4">partner spending </tspan><tspan x="-10.16" y="28.8">on commodity </tspan><tspan x="-5.39" y="43.2">procurement</tspan>`
  },
  {
    id: "type9",
    tx: 1000.576,
    ty: 631.9773,
    content: `<tspan x="0" y="0">Spending by </tspan><tspan x="3.72" y="14.4">individuals </tspan><tspan x="-13.88" y="28.8">accessing FP from </tspan><tspan x="-5.83" y="43.2">private sources</tspan>`
  }
];
